import { render, staticRenderFns } from "./SalesDetailHeader.vue?vue&type=template&id=3255a33f&scoped=true&"
import script from "./SalesDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./SalesDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SalesDetailHeader.vue?vue&type=style&index=0&id=3255a33f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3255a33f",
  null
  
)

export default component.exports